<template>
    <section class="bg-light py-10" id="contato">
        <div class="container">
            <div class="card mb-n5 z-1">
                <div class="card-body p-5">
                    <div class="row align-items-center">
                        <div class="col-lg-6">
                            <h4>Ainda ficou com alguma dúvida?</h4>
                            <p class="lead text-gray-500 mb-0">
                                Preencha o formulário ao lado e te daremos uma
                                consultoria gratuita!
                            </p>
                        </div>
                        <div class="col-lg-6">
                            <b-form @submit.prevent="enviarContato">
                                <div
                                    class="input-group mb-2"
                                    :class="[
                                        {
                                            'has-error': errors.has('nome')
                                        }
                                    ]"
                                >
                                    <div class="w-100">
                                        <b-form-input
                                            class="form-control form-control-solid"
                                            name="nome"
                                            id="nome"
                                            v-model="data.Site.nome"
                                            placeholder="Nome"
                                            v-validate="'required|min:3'"
                                            autocomplete="off"
                                        ></b-form-input>
                                        <div v-show="errors.has('nome')">
                                            {{
                                                errors.first('nome') != ' '
                                                    ? errors.first('nome')
                                                    : 'Preenchimento obrigatorio'
                                            }}
                                        </div>
                                    </div>
                                </div>

                                <div
                                    class="input-group mb-2"
                                    :class="[
                                        {
                                            'has-error': errors.has('telefone')
                                        }
                                    ]"
                                >
                                    <div class="w-100">
                                        <b-form-input
                                            class="form-control form-control-solid"
                                            name="telefone"
                                            v-model="data.Site.telefone"
                                            placeholder="Telefone"
                                            v-validate="'required|min:13'"
                                            autocomplete="off"
                                            v-mascara-telefone
                                        ></b-form-input>
                                        <div v-show="errors.has('telefone')">
                                            {{
                                                errors.first('telefone') != ' '
                                                    ? errors.first('telefone')
                                                    : 'Preenchimento obrigatorio'
                                            }}
                                        </div>
                                    </div>
                                </div>
                                <div
                                    class="input-group mb-2"
                                    :class="[
                                        {
                                            'has-error': errors.has('email')
                                        }
                                    ]"
                                >
                                    <div class="w-100">
                                        <b-form-input
                                            class="form-control form-control-solid"
                                            name="email"
                                            v-model="data.Site.email"
                                            placeholder="E-mail"
                                            v-validate="'required|email'"
                                            autocomplete="off"
                                        ></b-form-input>
                                        <div v-show="errors.has('email')">
                                            {{
                                                errors.first('email') != ' '
                                                    ? errors.first('email')
                                                    : 'Preenchimento obrigatorio'
                                            }}
                                        </div>
                                    </div>
                                </div>
                                <div
                                    class="input-group mb-2"
                                    :class="[
                                        {
                                            'has-error': errors.has('interesse')
                                        }
                                    ]"
                                >
                                    <div class="w-100">
                                        <b-form-select
                                            class="form-control form-control-solid"
                                            :options="opcoes"
                                            name="interesse"
                                            v-model="data.Site.interesse"
                                            v-validate="'required'"
                                        >
                                        </b-form-select>
                                        <div v-show="errors.has('interesse')">
                                            Preenchimento obrigatorio
                                        </div>
                                    </div>
                                </div>
                                <div
                                    class="input-group mb-2"
                                    :class="[
                                        {
                                            'has-error': errors.has('assunto')
                                        }
                                    ]"
                                >
                                    <div class="w-100">
                                        <b-form-textarea
                                            class="form-control form-control-solid"
                                            v-model="data.Site.mensagem"
                                            placeholder="Assunto"
                                            name="assunto"
                                            rows="6"
                                            v-validate="'required'"
                                        ></b-form-textarea>
                                        <div v-show="errors.has('assunto')">
                                            Preenchimento obrigatorio
                                        </div>
                                    </div>
                                </div>
                                <div class="text-center">
                                    <button
                                        :disabled="enviando"
                                        type="submit"
                                        class="btn btn-primary btn-marketing mt-4"
                                    >
                                        <span v-if="enviando" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                        Enviar formulário
                                    </button>
                                </div>
                            </b-form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="svg-border-waves text-dark">
            <svg
                class="wave"
                style="pointer-events: none"
                fill="currentColor"
                preserveAspectRatio="none"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                viewBox="0 0 1920 75"
            >
                <defs>
                    <clippath id="a">
                        <rect class="a" width="1920" height="75"></rect>
                    </clippath>
                </defs>
                <title>wave</title>
                <g class="b">
                    <path
                        class="c"
                        d="M1963,327H-105V65A2647.49,2647.49,0,0,1,431,19c217.7,3.5,239.6,30.8,470,36,297.3,6.7,367.5-36.2,642-28a2511.41,2511.41,0,0,1,420,48"
                    ></path>
                </g>
                <g class="b">
                    <path
                        class="d"
                        d="M-127,404H1963V44c-140.1-28-343.3-46.7-566,22-75.5,23.3-118.5,45.9-162,64-48.6,20.2-404.7,128-784,0C355.2,97.7,341.6,78.3,235,50,86.6,10.6-41.8,6.9-127,10"
                    ></path>
                </g>
                <g class="b">
                    <path
                        class="d"
                        d="M1979,462-155,446V106C251.8,20.2,576.6,15.9,805,30c167.4,10.3,322.3,32.9,680,56,207,13.4,378,20.3,494,24"
                    ></path>
                </g>
                <g class="b">
                    <path
                        class="d"
                        d="M1998,484H-243V100c445.8,26.8,794.2-4.1,1035-39,141-20.4,231.1-40.1,378-45,349.6-11.6,636.7,73.8,828,150"
                    ></path>
                </g>
            </svg>
        </div>
    </section>
</template>
<script>
import '@/shared/plugins/recaptcha'
import '@/shared/common/directives/mascaras/telefone'
export default {
    $_veeValidate: {
        validator: 'new'
    },
    props: ['app'],
    data() {
        return {
            enviando: false,
            opcoes: [
                {
                    value: '',
                    text: 'Qual seu interesse?'
                },
                {
                    value: 'Desejo abrir uma empresa',
                    text: 'Desejo abrir uma empresa'
                },
                {
                    value: 'Já tenho empresa aberta',
                    text: 'Já tenho empresa aberta'
                },
                {
                    value: 'Sou contador e quero mais informações',
                    text: 'Sou contador e quero mais informações'
                },
                {
                    value: 'Sou estudante e quero aprender mais',
                    text: 'Sou estudante e quero aprender mais'
                },
                {
                    value: 'Descobrir o melhor formato para minha empresa',
                    text: 'Descobrir o melhor formato para minha empresa'
                },
                {
                    value: 'Quero mudar de contador',
                    text: 'Quero mudar de contador'
                }
            ],
            data: {
                Site: {
                    nome: '',
                    telefone: '',
                    email: '',
                    interesse: '',
                    mensagem: '',
                    'g-recaptcha-response': ''
                },
            },
        }
    },
    async mounted() {
        // Se recaptcha carregado com sucesso, exibe
        if (await this.$recaptchaLoaded()) {
            this.$recaptchaInstance.showBadge()
        }
    },
    methods: {
        async enviarContato() {
            const validado = await this.$validator.validateAll()
            if (!validado) {
                return false
            }
            this.enviando = true
            const recaptcha = await this.$recaptcha('login')
            this.data.Site['g-recaptcha-response'] = recaptcha

            let dados = {
                data: this.data,
            }

            const retorno = await this.$api.post(
                 this.$urlBase + '/envia_contato', 
                dados
            )

            if (retorno.status == 'success') {
                this.$dialog.success(retorno.message)
                this.data =  {
                Site: {
                    nome: '',
                    telefone: '',
                    email: '',
                    interesse: '',
                    mensagem: '',
                    'g-recaptcha-response': ''
                },
            }
            } else {
                this.$dialog.error(retorno.message)
            }
            this.enviando = false
            
        }
    }
}
</script>
<style scoped>
.a {
    fill: none;
}
.b {
    clip-path: url(#a);
}
.d {
    opacity: 0.5;
    isolation: isolate;
}
</style>
